import { ChevronDown, Home, RotateCcw, Trophy } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../api.js';
import MobileShell, { BrandFooter } from '../components/MobileShell.jsx';

export default function ResultPage() {
  const { attemptId } = useParams();
  const navigate = useNavigate();
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => { api(`/api/results/${attemptId}`).then(setResult).catch((requestError) => setError(requestError.message)); }, [attemptId]);
  if (error) return <div className="screen-loader">{error}</div>;
  if (!result) return <div className="screen-loader">正在生成成绩…</div>;

  return (
    <MobileShell className="result-page">
      <section className="result-card">
        <div className="result-eyebrow">第 {result.attemptNumber} 次答题完成</div>
        <div className="score-seal"><strong>{result.score}</strong><span>分</span></div>
        <h1>{result.score >= 80 ? '同心筑梦，答得漂亮！' : result.score >= 60 ? '顺利完成，再接再厉！' : '每一次学习都在进步'}</h1>
        <p>{result.correctCount} 题正确 · 用时 {(result.durationMs / 1000).toFixed(1)} 秒</p>
        <div className="result-summary">
          <div><span>本次成绩</span><b>{result.score}</b></div>
          <div><span>最高成绩</span><b>{result.bestScore}</b></div>
          <div><span>剩余次数</span><b>{result.attemptsRemaining}</b></div>
        </div>
        <div className={`result-actions${result.attemptsRemaining === 0 ? ' single-action' : ''}`}>
          {result.attemptsRemaining > 0 && <button className="primary-button" type="button" onClick={() => navigate('/')}><RotateCcw size={18} />再答一次</button>}
          <button className="secondary-button" type="button" onClick={() => navigate('/leaderboard')}><Trophy size={18} />查看排行榜</button>
        </div>
      </section>

      <section className="review-section">
        <h2>错题回顾 <span>{result.review.length ? `${result.review.length} 道` : '全部答对'}</span></h2>
        {result.review.length === 0 ? <div className="perfect-state">满分通关，你已掌握本次全部知识点。</div> : result.review.map((item, index) => (
          <details className="review-item" key={item.questionId}>
            <summary><span>{index + 1}</span><b>{item.timedOut ? '本题超时' : '答案有误'}</b><ChevronDown size={18} /></summary>
            <h3>{item.stem}</h3>
            <div className="review-answer"><span>你的答案：{item.selected.join('、') || '未作答'}</span><b>正确答案：{item.answer.join('、')}</b></div>
            {item.explanation && <p>{item.explanation}</p>}
          </details>
        ))}
        <button className="text-button" type="button" onClick={() => navigate('/')}><Home size={16} />返回首页</button>
      </section>
      <BrandFooter />
    </MobileShell>
  );
}
